import { Api } from '.'
import store from '../state/store.js'

import {
  fetchTearoomMenuError,
  fetchTearoomMenuSuccess
} from '../state/tearoom'

export function fetchTearoomMenu (config) {
  const api = new Api(
    config,
    (response) => {
      const { data } = response
      store.dispatch(fetchTearoomMenuSuccess(data))
    },
    (error) => {
      const { detail } = error
      store.dispatch(fetchTearoomMenuError({ detail }))
    }
  )

  api.fetch('tearoom/menu/default')
}
